import React, { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { ClassTypeContext } from "../context/ClassTypesContext";
import { ProgramsContext } from "../context/ProgramsContext";
import { FiltersContext } from "../context/FiltersContext";
import ClassTypesGrid from "../components/classTypes/ClassTypesGrid";
import OnlineHeader from "../components/global/OnlineHeader";
import FilterClassType from "../components/classTypes/FilterClassType";
import { Link } from "@reach/router";
import CustomerUpgrade from "../components/customers/CustomerUpgrade";
import { ModalContext } from "../context/ModalContext";

const VideoProgram = ({ program_url }) => {
  const { modalComponent } = useContext(ModalContext);
  const { clearClassTypes } = useContext(ClassTypeContext);
  const { user, getUsuario } = useContext(AuthContext);
  const { program_id, setFilter } = useContext(FiltersContext);
  const { program, getSingleProgram } = useContext(ProgramsContext);

  useEffect(() => {
    getUsuario();
    clearClassTypes();
    getSingleProgram(program_url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [program_url]);

  useEffect(() => {
    if (program_id === null) {
      getSingleProgram(program_url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [program_id]);

  useEffect(() => {
    if (program !== null) {
      setFilter("program_id", program.program_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [program]);

  useEffect(() => {
    if (!user.has_access) {
      modalComponent(
        "Suscríbete a TBM",
        <CustomerUpgrade feature="Clases Online" />
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const getTitle = () => {
    if (program && program !== null) {
      return program.name;
    }
  };

  const renderClassTypes = () => {
    if (!user.has_access) {
      return (
        <div className="container-fluid">
          <p>
            Lo sentimos, no cuentas con una membresía activa para TBM Online
          </p>
          <Link className="btn btn-primary" to="/mytbm/paquetes">
            Ir a Paquetes
          </Link>
        </div>
      );
    }
    return <ClassTypesGrid title="Tipos de Clases" />;
  };

  return (
    <div className="container-fluid px-md-5">
      <OnlineHeader title={getTitle()} backEnabled />
      {program_id !== null && <FilterClassType />}
      {renderClassTypes()}
    </div>
  );
};

export default VideoProgram;
